import { useMutation } from '@tanstack/react-query'
import type { RecordTutorialMilestoneRequest, RecordTutorialMilestoneResponse, TutorialMilestone } from '@warcarp/api-types'
import { apiPost } from '../lib/api'

/** Retries continue after navigation; the server preserves the first timestamp. */
export function useTutorialMilestones() {
  return useMutation({
    mutationFn: (milestone: TutorialMilestone) => apiPost<RecordTutorialMilestoneResponse>(
      '/api/v1/auth/me/tutorial-progress', { milestone } satisfies RecordTutorialMilestoneRequest),
    retry: 2,
  })
}
